export default __webpack_public_path__ + "images/jaliscoLogo.a9648e193af1d32c09383bb1d7097508.png";